import { ModelBase } from "@shoothill/core";
import { makeObservable, observable } from "mobx";
import { StudentAbsenceModel } from "Views/Students/Student/StudentReports/StudentAbsence/StudentAbsenceModel";
import { FilesViewModel } from "Views/Students/Student/StudentReports/Files/FilesViewModel";
import { StudentTargetModel } from "Views/Shared/Views/StudentTarget/StudentTargetModel";
import { StudentSessionAQACertificatesModel } from "Views/Shared/Views/StudentSessionAQACertificate/StudentSessionAQACertificatesModel";
import { StudentBehaviourModel } from "Views/Shared/Views/StudentBehaviour/StudentBehaviourModel";
import { MentorModel, StudentModel, SessionDocumentModel, StudentEngagementModel } from "./SupportingTypes";

export class StudentSessionContext extends ModelBase<StudentSessionContext> {
    //#region Core Properties
    public mentorId: string = "";
    public studentId: string = "";
    public sessionDate: Date | null = new Date();
    public sessionStartTime: string | Date | null = null;
    public sessionEndTime: string | Date | null = null;
    public sessionPlan: string | null = "";
    public sessionFeedback: string | null = "";
    public sessionStatusId: string = "";
    //#endregion

    //#region Optional Properties
    public activityOptionName: string = "";
    public activityTypeId: string | null = null;
    public attendance: string = "";
    public didAttend: boolean = false;
    public documentCategoryId: string = "";
    public involvementId: string = "";
    public reportIncident: boolean = false;
    public studentTargetIds: string[] = [];
    public wellbeingId: string = "";
    //#endregion

    //#region Legacy properties
    public subTargets: string = "";
    public mentoring: string = "";
    public isLegacy: boolean = false;
    //#endregion

    //#region Observable Collections
    public mentors = observable<MentorModel>([]);
    public sessionDocument = observable<SessionDocumentModel>([]);
    public studentTargets = observable<StudentTargetModel>([]);
    public wellbeing = observable<StudentEngagementModel>([]);
    public studentBehaviourModels = observable<StudentBehaviourModel>([]);
    public studentSessionAQACertificatesModel: StudentSessionAQACertificatesModel = new StudentSessionAQACertificatesModel();
    //#endregion

    //#region Related Model Instances
    public filesViewModel = new FilesViewModel();
    public sessionMentor = new MentorModel();
    public student: StudentModel = new StudentModel();
    public studentAbsence: StudentAbsenceModel = new StudentAbsenceModel();
    //#endregion

    constructor() {
        super();
        makeObservable(this, {
            mentorId: observable,
            studentId: observable,
            sessionDate: observable,
            sessionStartTime: observable,
            sessionEndTime: observable,
            sessionPlan: observable,
            sessionFeedback: observable,
            sessionStatusId: observable,
            activityOptionName: observable,
            activityTypeId: observable,
            attendance: observable,
            didAttend: observable,
            documentCategoryId: observable,
            involvementId: observable,
            reportIncident: observable,
            studentTargetIds: observable,
            wellbeingId: observable,
            subTargets: observable,
            mentoring: observable,
            isLegacy: observable,
            mentors: observable,
            sessionDocument: observable,
            studentTargets: observable,
            wellbeing: observable,
            studentBehaviourModels: observable,
            filesViewModel: observable,
            sessionMentor: observable,
            student: observable,
            studentAbsence: observable,
        });
    }
}
